export const REPLACE_CURRENT_USER = 'REPLACE_CURRENT_USER';
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER';
export const ADD_CURRENT_USER_PENDING_DOCUMENTS = 'ADD_CURRENT_USER_PENDING_DOCUMENTS';
export const RESET_CURRENT_USER_PENDING_DOCUMENTS = 'RESET_CURRENT_USER_PENDING_DOCUMENTS';
export const RESET_CURRENT_USER = 'RESET_CURRENT_USER';
export const SET_CURRENT_USER_DIRTY = 'SET_CURRENT_USER_DIRTY';
